import { faEraser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Tooltip, Whisper } from 'rsuite';

export default function resetMemory() {
    return (
        <div data-cy="historic-restart">
            <Whisper
                placement="right"
                trigger="hover"
                speaker={
                    <Tooltip>
                        <FormattedMessage id="history.resetMemory" />
                    </Tooltip>
                }>
                <FontAwesomeIcon icon={faEraser} style={{ color: 'red' }} size="lg" />
            </Whisper>
        </div>
    );
}
